export enum MButtonThemes {
  Filled = 'filled',
  Border = 'border',
  Text =  'text',
}
